import { useQuery } from '@tanstack/react-query';
import {
  listEventGroupTargets,
  listEventRoleTargets,
  resolveEventAudience,
} from '../services/event-targets';
import type { EventAudienceMetadata } from '../types/events.types';
import { eventKeys } from './useEvents';

export function useEventAudienceMetadata(eventId: number, isAdmin: boolean) {
  return useQuery<EventAudienceMetadata>({
    queryKey: [...eventKeys.detail(eventId), 'audience-metadata'],
    queryFn: async () => {
      const [roleTargets, groupTargets, resolvedMembers] = await Promise.all([
        listEventRoleTargets(eventId),
        listEventGroupTargets(eventId),
        resolveEventAudience(eventId),
      ]);

      return {
        roleTargets,
        groupTargets,
        resolvedMemberCount: resolvedMembers.length,
      };
    },
    enabled: isAdmin,
    staleTime: 60 * 1000,
  });
}
